module.exports = __webpack_public_path__ + "img/doneMark.760bc0cb.svg";